// Constants
import { TableName } from "@ms/uno-constants/lib/local/StoreConstants";
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/** Maps each cache data table to its configured eviction TTL setting key. */ const ttlSettingByTable = {
    [TableName.UserPhotos]: "userPhotosTtlInDays",
    [TableName.ModernGroupPhotos]: "modernGroupPhotosTtlInDays",
    [TableName.Users]: "usersTtlInDays"
};
/**
 * Reads the configured eviction TTL (in days) for a cache data table.
 * @param configProvider Provider for app configuration
 * @param dataTable Cache data table whose TTL to read
 */ export function getTtlInDays(configProvider, dataTable) {
    return configProvider().settings.workerSettings.cacheEvictionWorker[ttlSettingByTable[dataTable]];
}
/**
 * Determines whether a persisted status is stale per the TTL policy.
 *
 * This logic is intentionally shared between the eviction worker (which purges stale cached items) and the
 * fetch worker (which must skip restoring those same stale items). Keeping the two in lockstep prevents
 * the restore -> evict -> rebuild-from-store race: if the fetch worker restored a stale cached item into the
 * store, the cache-update worker would re-persist it right after the eviction worker purged it, defeating
 * TTL-based eviction. A cached item with no timestamp (unknown age) is treated as stale.
 *
 * @param persistedStatus Persisted status for the cached item
 * @param ttlInDays Configured eviction TTL for the cache data table
 * @param now Current instant used to measure age (pass a single value when evaluating a batch)
 */ export function isPersistedStatusStale(persistedStatus, ttlInDays, now) {
    if (persistedStatus.timestamp == null) {
        return true;
    }
    const timestamp = Temporal.Instant.from(persistedStatus.timestamp).toZonedDateTimeISO("UTC");
    const ageInDays = timestamp.until(now).total({
        unit: "days"
    });
    return ageInDays > ttlInDays;
}
